import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "input-group" };
const _hoisted_2 = ["id", "disabled", "value"];
const _hoisted_3 = ["value", "disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormElementDescription = _resolveComponent("FormElementDescription");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("select", {
            class: "form-select form-select-sm",
            id: _ctx.id,
            disabled: _ctx.disabled,
            onInput: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
            value: _ctx.modelValue
        }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsToUse, (opt) => {
                return (_openBlock(), _createElementBlock("option", {
                    value: opt.val,
                    key: opt.val,
                    disabled: opt.disabled === true
                }, _toDisplayString(opt.description), 9, _hoisted_3));
            }), 128))
        ], 40, _hoisted_2),
        _createVNode(_component_FormElementDescription, { description: _ctx.description }, null, 8, ["description"])
    ]));
}
